export default "__VITE_ASSET__GDDIobse__"